import { render, staticRenderFns } from "./BilibiliChannel.vue?vue&type=template&id=00a30536&"
import script from "./BilibiliChannel.vue?vue&type=script&lang=js&"
export * from "./BilibiliChannel.vue?vue&type=script&lang=js&"
import style0 from "./BilibiliChannel.vue?vue&type=style&index=0&id=00a30536&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports